<template>
  <v-card class="my-2">
    <v-card-text class="text-h5">
      <v-row>
        <v-col cols="auto">
          <span class="text-overline">{{ sectionDisplay }}</span>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-checkbox
            v-model="selected"
            hide-details
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { humanize } from '@/utilities/string-utilities'

import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'PEPartySectionPreview',

  props: {
    property: {
      type: String,
      required: true,
    },

    section: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      selected: false,
    }
  },

  computed: {
    optionsCountries () { return this.getCachedDropdown('countries') },

    sectionDisplay () {
      return this.sectionFields.map(f => this.safeValue(f)).join(', ')
    },

    sectionFields () {
      switch (this.property) {
        case 'emails':
          return [
            ['owner', null],
            ['address', this.wrapperEmail],
          ]
        case 'phones':
          return [
            ['owner', null],
            ['phone_number', this.wrapperPhone],
          ]
        case 'residence_histories':
          return [
            ['address', null],
            ['city', null],
            ['country_id', this.countryName],
          ]
        case 'job_histories':
          return [
            ['job_title', null],
            ['company', null],
            ['country_id', this.countryName],
          ]
        case 'addresses':
          if (this.section.same_as_physical) return ['Same as physical address']

          return [
            ['address', null],
            ['city', null],
            ['country_id', this.countryName],
          ]
      }

      return ''
    },

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  watch: {
    selected (value) {
      this.$emit('input', {
        id: this.section.id,
        section: this.section,
        selected: value,
      })
    },
  },

  created () {
    this.loadRequiredDropdowns()
  },

  methods: {
    countryName (countryId) { return this.optionsCountries?.find(o => o.id === countryId)?.name },

    loadRequiredDropdowns () {
      switch (this.property) {
        case 'residence_histories':
          this.getDropdownOptions({ options: false, path: 'countries' })
          break
      }
    },

    safeValue (fieldProp) {
      if (!Array.isArray(fieldProp)) return fieldProp

      const property = fieldProp[0]
      const processFunction = fieldProp[1]
      const value = this.section[property]

      let output = `${humanize(property).replace(/\bid\b/gi, '')}: `

      if (value && processFunction) output += processFunction(value)
      else if (value === null) output += 'N/A'
      else output += value

      return output
    },

    wrapperEmail: email => `<${email}>`,
    wrapperPhone: phone => `<${phone}>`,

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
